import React, { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import ExperimentNav from '../../components/ExperimentNav';
import { experiments } from '../../App';
import './CircleReveal.css';

gsap.registerPlugin(ScrollTrigger);

const images = [
  'https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=1920&q=80',
  'https://images.unsplash.com/photo-1470071459604-3b5ec3a7fe05?w=1920&q=80',
  'https://images.unsplash.com/photo-1682687220742-aba13b6e50ba?w=1920&q=80',
];

const CircleReveal: React.FC = () => {
  const wrapperRef = useRef<HTMLDivElement>(null);
  const panelsRef = useRef<(HTMLDivElement | null)[]>([]);
  const exp = experiments.find((e) => e.id === 'circle-reveal');

  useEffect(() => {
    const ctx = gsap.context(() => {
      // Panel 2 and 3: animate circle clip from 0 to full
      [1, 2].forEach((i) => {
        const panel = panelsRef.current[i];
        if (!panel) return;

        // The trigger is the corresponding spacer section
        const trigger = document.getElementById(`cr-spacer-${i}`);

        gsap.fromTo(
          panel,
          { clipPath: 'circle(0% at 50% 50%)' },
          {
            clipPath: 'circle(100% at 50% 50%)',
            ease: 'none',
            scrollTrigger: {
              trigger: trigger,
              start: 'top top',
              end: 'bottom top',
              scrub: 0.5,
            },
          }
        );
      });
    }, wrapperRef);

    return () => ctx.revert();
  }, []);

  return (
    <div ref={wrapperRef} className="cr-wrapper">
      <div className="cr-scanlines" />
      <ExperimentNav prompt={exp?.prompt} title={exp?.title} />

      {/* Fixed stacking panels */}
      <div className="cr-fixed">
        {images.map((src, i) => (
          <div
            key={i}
            ref={(el) => { panelsRef.current[i] = el; }}
            className="cr-panel"
            style={{ zIndex: i + 1 }}
          >
            <img src={src} alt="" className="cr-image" />
            <div className="cr-overlay">
              <span className="cr-index">0{i + 1}</span>
            </div>
          </div>
        ))}
      </div>

      {/* Spacer sections to create scroll distance */}
      <div className="cr-spacer" id="cr-spacer-0" />
      <div className="cr-spacer" id="cr-spacer-1" />
      <div className="cr-spacer" id="cr-spacer-2" />
      <div className="cr-spacer" id="cr-spacer-end" />
    </div>
  );
};

export default CircleReveal;
